// src/pages/admin/SystemAlerts.js
import React from 'react';
import { Card, List, Badge } from 'antd';

const SystemAlerts = ({ systemAlerts }) => (
  <Card title="System Alerts" bordered={false} style={{ marginBottom: 16 }}>
    <List
      dataSource={systemAlerts.slice(0, 5)}
      renderItem={(item) => (
        <List.Item>
          <Badge status="warning" text={`${item.message} - ${item.date}`} />
        </List.Item>
      )}
    />
  </Card>
);

export default SystemAlerts;